module.exports = __webpack_public_path__ + "static/media/pic2.aa6af38f.jpg";